import { request } from '../axios/request';

import {
  PACKAGE_OMS_COMMAND_PENDING,
  PACKAGE_OMS_COMMAND_REJECTED,
  PACKAGE_OMS_COMMAND_FULFILLED,
  CLEAR_PACKAGE_OMS_COMMAND,
} from '../constants/packageOmsCommand';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: PACKAGE_OMS_COMMAND_PENDING,
});

const fulfilled = (response) => ({
  type: PACKAGE_OMS_COMMAND_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: PACKAGE_OMS_COMMAND_REJECTED,
  error,
});

export const clearOmsCommand = () => ({
  type: CLEAR_PACKAGE_OMS_COMMAND,
});

export const omsCommand =
  (packageOrderId, selectedIds, actionParams) => (dispatch) => {
    const {
      id: transition,
      source_state,
      destination_state,
      inputParameters = {},
    } = actionParams;
    const url = OMS.OMS.PACKAGE_ORDER_DETAIL_COMMAND.replace(
      '{0}',
      packageOrderId
    );

    const data = {
      input_parameters: {
        package_items: selectedIds,
        ...inputParameters,
      },
      transition,
      source_state,
      destination_state,
    };

    dispatch(pending());

    request({
      method: 'POST',
      url,
      data,
    })
      .then((response) => {
        dispatch(fulfilled(response));
      })
      .catch((error) => {
        dispatch(rejected({ apiError: error }));
      });
  };

export const manuelOmsCommand =
  (packageOrderId, selectedIds, actionParams, extraData) => (dispatch) => {
    const {
      id: transition,
      source_state,
      destination_state,
      command,
    } = actionParams;
    const url = OMS.OMS.PACKAGE_ORDER_DETAIL_COMMAND.replace(
      '{0}',
      packageOrderId
    );

    const data = {
      command,
      configuration: {},
      label: 'Paketi manuel planla',
      input_parameters: {
        assignment_groups: extraData,
      },
      transition: transition,
      id: transition,
      source_state,
      is_packageitem_parameter_required: false,
      translations: null,
      destination_state,
    };

    dispatch(pending());

    request({
      method: 'POST',
      url,
      data,
    })
      .then((response) => {
        dispatch(fulfilled(response));
      })
      .catch((error) => {
        dispatch(rejected({ apiError: error }));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/packageOmsCommand.js